import { isMobile } from "react-device-detect";
import { Toast } from "antd-mobile";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { collectApi } from "../../api/collect-api";
import { financeApi } from "../../api/finance-api";
import { homeApi } from "../../api/home-api";
import { kuangjiApi } from "../../api/kuangm-api";
import BottomBar from "../../components/bottomBar";
import TopBar from "../../components/topBar";
import { LoginMsgContext, WSContext } from "../../router/router";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
import 'tailwindcss/tailwind.css'
import { PcHeader } from "@/components/acendex/components/pc-header/pc-header";

export default function QuotationCenter() {
  const uid = localStorage.getItem("uid");
  const navigate = useNavigate();
  const prarm = useParams();
  const [userCoinInfo, setuserCoinInfo] = useState({});
  const { t: translate } = useTranslation();
  const [coinListData, setCoinListData] = useContext(WSContext);
  const [ctmarketlist, setCtmarketlist] = useState([] as any[]);
  const [collectlist, setcollectlist] = useState([] as any[]);

  const loadctmarketlistData = async () => {
    const data = await homeApi.ctmarketlist({ pageNum: 1, pageSize: 100 });
    if (data.ok) {
      const list = data.data.records;
      list.sort((d, e) => d.sort - e.sort);
      setCtmarketlist(list);
    }
  };

  //去重
  function uniqueBySet(arr, key) {
    const uniqueSet = new Set();
    const uniqueArray = [];
    for (const item of arr) {
      const keyValue = item[key];
      if (!uniqueSet.has(keyValue)) {
        uniqueArray.push(item);
        uniqueSet.add(keyValue);
      }
    }
    return uniqueArray;
  }
  
  const loadcollectlistData = async () => {
    const data = await collectApi.list({ uid, pageNum: 1, pageSize: 100 });
    if (data.ok) {
      data.data = uniqueBySet(data.data, "coinname");
      setcollectlist(data.data);
    }
  };
  
  useEffect(() => {
    loadctmarketlistData();
    loadcollectlistData();
  }, []);
  
  return (
    <div className="min-h-screen bg-neutral-900 flex flex-col">
    {isMobile ? <TopBar title={translate(getText("行情"))} isBack={false} /> : <PcHeader />}
      <div className="flex-1 md:pb-0 pb-16 px-2 pt-2">
        <CenterPage
          coinListData={coinListData}
          ctmarketlist={ctmarketlist}
          collectlist={collectlist}
        />
      </div>
      {isMobile ? <BottomBar index={2} /> : null}
    </div>
  );
}
